import { useAuth } from "./useAuth";

interface UsePermissionsReturn {
    hasPermission: (resource: string, action: string) => boolean;
    permissions: string[];
}

export const usePermissions = (): UsePermissionsReturn => {
    const { user } = useAuth();

    const permissions = user?.permissions ?? [];

    const hasPermission = (resource: string, action: string): boolean => {
        if (!user) return false;

        // SUPER ADMIN
        if (permissions.includes("all")) return true;

        return permissions.includes(`${resource}:${action}`);
    };

    return {
        hasPermission,
        permissions,
    };
};
